import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Link from 'next/link';

import Typography from '../../atoms/typography';

export const Category = styled(Typography)`
  color: ${(props) => (props.active ? props.theme.color.brand : props.theme.color.brandLight)};
  cursor: pointer;
  display: block;
  line-height: 3rem;
  text-decoration: none;
  transition: color ${(props) => props.theme.animation.default} ${(props) => props.theme.animation.ease};

  :hover {
    color: ${(props) => props.theme.color.brand};
  }
`;

const CategoryTrigger = styled.details`
  position: relative;
  outline: 0;

  ol {
    transition: all ${(props) => props.theme.animation.default} ${(props) => props.theme.animation.ease};
  }

  summary {
    outline: none;
    line-height: 3rem;

    ::after {
      ${(props) => props.theme.arrow('down', props.active ? props.theme.color.brand : props.theme.color.brandLight, 'right 1px center', 4)}
      content: '';
      position: absolute;
      right: 0;
      height: 3rem;
      width: 100%;
      transition: background-image ${(props) => props.theme.animation.fast} ${(props) => props.theme.animation.ease};
    }

    ::-webkit-details-marker,
    ::before {
      display: none !important;
    }
  }

  &[open] {
    > summary::after {
      ${(props) => props.theme.arrow('up', props.active ? props.theme.color.brand : props.theme.color.brandLight, 'right 1px center', 4)}
    }
  }
`;

const CategoryList = (props) => {
  const toggleAccordion = (e) => {
    const elem = e.target;
    const parent = elem.closest('li');
    const list = parent.parentNode;

    let sibling = list.firstChild;

    for (; sibling; sibling = sibling.nextSibling) {
      if (sibling.nodeType === 1 && sibling !== parent) {
        [...sibling.querySelectorAll('details')].map((x) => x.removeAttribute('open'));
      }
    }
  };

  return (
    <li>
      <CategoryTrigger open={props.cat1.selected} onClick={toggleAccordion}>
        <Category element="summary" like="dec-1" active={props.cat1?.selected ? 'true' : undefined}>
          {props.cat1?.name}
        </Category>
        <ol>
          <li>
            <Link href={props.getHrefValue([props.cat1.id])} passHref>
              <Category element="a" like="dec-1" active={props.cat1?.selected ? 'true' : undefined}>
                {`All ${props.cat1?.name}`}
              </Category>
            </Link>
          </li>

          {
            props.categories?.defaults?.[1]?.values?.filter((c) => c.id.split('_')[0] === props.cat1.id)?.map((cat2) => (
              <li key={cat2?.id}>
                <CategoryTrigger open={cat2.selected} onClick={toggleAccordion}>
                  <Category element="summary" like="dec-1" active={cat2?.selected ? 'true' : undefined}>
                    {cat2?.name}
                  </Category>
                  <ol>
                    <li>
                      <Link href={props.getHrefValue([props.cat1.id, cat2.id.split('_')[1]])} passHref>
                        <Category element="a" like="dec-1" active={cat2?.selected ? 'true' : undefined}>
                          {`All ${cat2?.name}`}
                        </Category>
                      </Link>
                    </li>

                    {
                      props.categories?.defaults?.[2]?.values?.filter((x) => x.id.split('_').slice(0, 2).join('_') === cat2.id)?.map((cat3) => (
                        <li key={cat3.id}>
                          <Link href={props.getHrefValue([props.cat1.id, cat2.id.split('_')[1], cat3.id.split('_')[2]])} passHref>
                            <Category element="a" like="dec-1" active={cat3?.selected ? 'true' : undefined}>
                              {cat3?.name}
                            </Category>
                          </Link>
                        </li>
                      ))
                    }
                  </ol>
                </CategoryTrigger>
              </li>
            ))
          }
        </ol>
      </CategoryTrigger>
    </li>
  );
};

CategoryList.propTypes = {
  cat1: PropTypes.object.isRequired,
  categories: PropTypes.object.isRequired,
  getHrefValue: PropTypes.func.isRequired
};

export default CategoryList;
